import React, { Component } from 'react'

import './Video.scss'
import Video from '../Header/Video'

class VideoCard extends Component {
  render() {
    return (
      <div className="video-card col grid-2">
        <div className="col video-box">
          <Video videoId={"3k_0KhA9-ho"} background={require('../../sass/images/video-bg.png')} />
        </div>
        <div className="col">

          <div className="header">
            <div className="level">
              Nível: <span>iniciante</span>
            </div>
            <div className="tags">
              Tags: <span>cadastro</span>, <span>início</span>, <span>login</span>, <span>perfil</span>
            </div>
          </div>

          <div className="content">
            <h2>Iniciando no Talkative: truques e dicas para o seu primeiro uso da ferramenta</h2>
            <p>As experiências acumuladas demonstram que o comprometimento entre as equipes deve passar por modificações independentemente do orçamento setorial.</p>
          </div>

        </div>
      </div>
    );
  }
}

export default VideoCard;



// WEBPACK FOOTER //
// ./src/components/Card/Video.js